import { useDispatch, useSelector } from 'react-redux';
import { saveSettingsBuffer, fetchHasBufferedSettingsChanges } from '../actions/ThemeSettingsActions';
import { getThemeSettingsLastSave, getIsThemeSettingsLastSaveUniversal } from '../selectors/themeSettingsSelectors';
import { useCallback } from 'react';
const AUTOSAVE_DEBOUNCE_PERIOD = 500;
export const useUniversalThemeSave = () => {
  const dispatch = useDispatch();
  const lastThemeSave = useSelector(getThemeSettingsLastSave);
  const lastSaveIsUniversal = useSelector(getIsThemeSettingsLastSaveUniversal);
  const saveThemeSettingsAction = useCallback(({
    isAutoSave,
    fromUniversal
  }) => {
    return setTimeout(() => {
      dispatch(saveSettingsBuffer({
        isAutoSave,
        fromUniversal
      })).catch(e => console.error(e));
      dispatch(fetchHasBufferedSettingsChanges());
    }, AUTOSAVE_DEBOUNCE_PERIOD);
  }, [dispatch]);
  const getUniversalThemeSupportedLastSave = useCallback(contentLastSave => {
    if (lastThemeSave && lastThemeSave > contentLastSave.getTime() && lastSaveIsUniversal) {
      return lastThemeSave;
    }
    return contentLastSave;
  }, [lastThemeSave, lastSaveIsUniversal]);
  return {
    saveThemeSettingsAction,
    getUniversalThemeSupportedLastSave
  };
};